// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import styled, { keyframes } from 'styled-components';

import useMergeProps from '../../../hooks/useMergeProps';
import useBoomWelcomeAnimationUtils from '../../boom/hooks/useBoomWelcomeAnimationUtils';
import WelcomeAnimation from '../components/common/WelcomeAnimation';
import selectBoomWelcomeAnimationProps from '../selectors/specifics/selectBoomWelcomeAnimationProps';

const transitionClassNamePrefix = 'boom-welcome-animation-transition';

const APPEARANCE_TIMEOUT = 200;

const appearAnim = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const StyledWelcomeAnimation = styled(WelcomeAnimation)`
  &.${transitionClassNamePrefix}-enter {
    animation: ${appearAnim} ${APPEARANCE_TIMEOUT}ms ease-out forwards;
  }

  &.${transitionClassNamePrefix}-exit {
    animation: ${appearAnim} ${APPEARANCE_TIMEOUT}ms ease-out forwards reverse;
  }
`;

type BoomWelcomeAnimationContainerProps = {
  className?: string;
};

const BoomWelcomeAnimationContainer = (ownProps: BoomWelcomeAnimationContainerProps) => {
  const [shouldShow, setHasBeenViewed] = useBoomWelcomeAnimationUtils();

  const selectedProps = useSelector(selectBoomWelcomeAnimationProps);

  const onAnimationEnd = useCallback(() => {
    setHasBeenViewed(true);
  }, [setHasBeenViewed]);

  const otherProps = useMemo(
    () => ({
      onAnimationEnd,
    }),
    [onAnimationEnd],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return (
    <CSSTransition
      in={shouldShow && !!selectedProps.animationId}
      timeout={APPEARANCE_TIMEOUT}
      classNames={transitionClassNamePrefix}
      mountOnEnter
      unmountOnExit
    >
      <StyledWelcomeAnimation {...enhancedProps} />
    </CSSTransition>
  );
};

export default BoomWelcomeAnimationContainer;
